import { render, staticRenderFns } from "./WorkshopRoster.vue?vue&type=template&id=565baadf"
import script from "./WorkshopRoster.vue?vue&type=script&lang=js"
export * from "./WorkshopRoster.vue?vue&type=script&lang=js"
import style0 from "./WorkshopRoster.vue?vue&type=style&index=0&id=565baadf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports